import React, { useState } from 'react'
import { getTheme } from '@/utils/theme'
import { createForm } from '@formily/core'
import { createSchemaField } from '@formily/react'
import { Form, FormItem, Input, Password, Submit } from '@formily/antd'
import { VerifyCode } from '../VerifyCode'
import {
  LoginReq,
  UpdatePassReq,
  UserDomainEnum,
  authApi,
  reflectionApi,
} from 'packages/sdks-next/growp'
import { isValidPhoneNumber } from '@seiue/util'
import { useCurrentSchoolId } from '@/hooks'
import { Toast } from '@seiue/ui'
import { usePasswordSchema, usePhoneSchema } from './schema'
import { GrowpIcon } from 'packages/components/GrowpIcon'
import styled from 'styled-components'
const form = createForm({
  validateFirst: true,
})
const pwdForm = createForm({
  validateFirst: true,
})

const SchemaField = createSchemaField({
  components: {
    FormItem,
    Input,
    Password,
    VerifyCode,
  },
})

export const RetrievePassword: React.FC<{
  isPreview?: boolean
  cancelChangePassword: () => void
}> = ({ isPreview, cancelChangePassword }) => {
  const theme = getTheme()
  const [step, setStep] = useState<number>(1)
  const schoolId = useCurrentSchoolId()
  const phoneSchema = usePhoneSchema(isPreview)
  const passwordSchema = usePasswordSchema()
  return (
    <>
      <div
        style={{
          cursor: 'pointer',
        }}
        onClick={() => {
          if (step === 1) {
            cancelChangePassword()
          } else {
            setStep(1)
          }
        }}
      >
        <GrowpIcon
          name="Right"
          text="返回"
          size={16}
          hoverColor={theme.brand._1}
        />
      </div>
      <Title>{step === 1 ? '找回密码' : '重置密码'}</Title>
      {step === 1 ? (
        <Form
          form={form}
          layout="vertical"
          size="large"
          onAutoSubmit={async (val: LoginReq) => {
            if (
              isPreview ||
              !isValidPhoneNumber(val.phone || '') ||
              !val.reminderId ||
              !val.phone
            ) {
              return
            }
            try {
              const { data } = await authApi.checkReminder({
                phone: val.phone,
                password: val.reminderId,
              })
              if (data === true) {
                setStep(2)
              }
            } catch (e: any) {
              const { data } = e.response
              Toast.error(data?.message)
            }
          }}
        >
          <SchemaField schema={phoneSchema} />
          <StyledSubmit
            block={true}
            size="large"
          >
            下一步
          </StyledSubmit>
        </Form>
      ) : (
        <Form
          form={pwdForm}
          layout="vertical"
          size="large"
          onAutoSubmit={async (val: UpdatePassReq) => {
            if (isPreview || !val.password) {
              return
            }
            const phone = form.getFormState().values.phone
            try {
              await reflectionApi.updateSelfPass('teacher', phone, {
                schoolId,
                password: val.password,
                repeatPassword: val.repeatPassword,
              })
              Toast.success('密码修改成功')
              setStep(1)
              cancelChangePassword()
            } catch (e: any) {
              const { data } = e.response
              Toast.error(data?.message)
            }
          }}
        >
          <SchemaField schema={passwordSchema} />
          <StyledSubmit
            block={true}
            size="large"
          >
            完成
          </StyledSubmit>
        </Form>
      )}
    </>
  )
}

const StyledSubmit = styled(Submit)`
  margin-top: 110px;
`

const Title = styled.div`
  margin-top: 20px;
  margin-bottom: 32px;
  font-size: 28px;
  text-align: left;
  color: ${(props) => props.theme.text._1};
`
